import { TagDTO } from '@gearbelt/global';

import { Badge, BadgeProps } from '@/components/ui/badge';

export function TagBadges({ tags, variant }: { tags?: TagDTO[] | null; variant?: BadgeProps['variant'] }) {
  return tags && tags.length > 0 ? (
    <div className="flex items-center gap-1">
      {tags.map(({ id, tag }) => (
        <Badge key={id} size="sm" variant={variant}>
          {tag}
        </Badge>
      ))}
    </div>
  ) : (
    <span className="text-secondary-text">-</span>
  );
}
